module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/sections/social_proof/assets/arrow_with_loop-a256f105dc3f6209e4f0f27bf0b823d2.png";